import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorNotFoundComponent } from './components/error-not-found/error-not-found.component';

const routes: Routes = [
    { path: 'error-404', component: ErrorNotFoundComponent }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule]
})
export class ErrorsRoutingModule {}